class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.vetCodeSection = document.querySelector("vet-code");
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.initaliseRecharge();
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });
    this.querySelector('button[type="button"].cart-notification__continue').addEventListener('click', this.close.bind(this));
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    this.querySelector('button[type="button"].cart-notification__continue').removeEventListener('click', this.close.bind(this));
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    if (this.vetCodeSection) this.vetCodeSection.setDiscountInputs();

    if (this.header) this.header.reveal();
    this.initaliseRecharge();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'cart-notification-buttons'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }



  // Recharge
  get_cart_token() {
    // Build the cart_token param for the URL generator
    try {
      return ['cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)')||0)[2]];
    } catch (e) {
      return [];
    }
  }
  get_ga_linker() {
    // Build the ga_linker param for the URL generator
    try {
      return [ga.getAll()[0].get('linkerParam')];
    } catch (e) {
      return [];
    }
  }

  buildCheckoutUrl(options) {
    // Build the Checkout URL
    var checkout_url = 'https://' + options.checkout_domain + '/r/checkout?',
      url_params = [
        'myshopify_domain=' + options.shop_domain,
      ];
    url_params = url_params
      .concat(this.get_cart_token())
      .concat(this.get_ga_linker());
    return checkout_url + url_params.join('&');
  }

  getCartJSON() {
    // Fetch the latest cart data from the /cart.js endpoint
    if (ReCharge.cart_options && !ReCharge.cart_options.cartjson) return {};
    return fetch('/cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(json) {
        return ({ cart: JSON.stringify(json) });
      })
      .catch(function(error) {
        console.error('Error retreiving cart: ', error);
        return ({ cart: JSON.stringify(ReCharge.cart)});
      });
  }

  buildCustomerObject(email_address, address_object) {
    // Return a data object with the customer shipping address
    var data = {
      email: email_address
    };
    try {
      return Object.assign(data, address_object);
    } catch (e) {
      return data
    }
  }

  getCartData(customer) {
    // Return cart attributes and data
    return this.getCartJSON().then(function(cartDataJSON) {
      var cart_data = {},
        cart_data = cartDataJSON,
        customer_data = this.buildCustomerObject(customer.email, customer.default_address);

      [cart_data, customer_data].forEach(function(obj) {
        Object.assign(cart_data, obj);
      });

      return cart_data;
    }.bind(this));
  }

  buildInputs(form, obj) {
    // Build input fields for key, value pairs
    Object.keys(obj).forEach(function(key) {
      var input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', key);
      input.setAttribute('value', typeof(obj[key]) === 'object' ? JSON.stringify(obj[key]) : obj[key]);
      form.appendChild(input);
    });
  }

  buildForm(data, url) {
    // Build a virtual form
    var form = document.createElement('form');
    form.setAttribute('method', 'post');
    form.setAttribute('action', url);
    form.setAttribute('id', 'rc_form');
    form.style.display = 'none';
    this.buildInputs(form, data);
    return form;
  }

  cartSubmit(options, customer) {
    // Build and submit cart
    return this.getCartData(customer).then(function(cart_data) {
      var checkout_url = this.buildCheckoutUrl(options);
      if (!cart_data) {
        window.location.href = checkout_url;
        return;
      }
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/update.js');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function() {
        if (xhr.status === 200) {
          // window.console.log('done', JSON.parse(xhr.responseText));
        } else if (xhr.status !== 200) {
          window.console.log('fail', JSON.parse(xhr.responseText));
        }
        var form = this.buildForm(cart_data, checkout_url);
        document.body.appendChild(form);
        form.submit();
      }.bind(this);
      xhr.send(JSON.stringify(cart_data));
    }.bind(this));
  }

  useRechargeCheckout() {
    const cartNotification = document.querySelector("cart-notification");
    const form = cartNotification.querySelector("form");
    if (form.classList.contains("rc_has-subscriptions")) {
      form.addEventListener('submit', (evt) => {
        evt.preventDefault();

        this.cartSubmit(ReCharge.cart_options, ReCharge.customer);
      });
    }
  }

  initaliseRecharge() {
    if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
      try {
        this.useRechargeCheckout();
      } catch(e) {
        window.console.log(e);
      }
    } else {
      try {
        document.addEventListener('DOMContentLoaded', this.useRechargeCheckout);
      } catch(e) {
        window.console.log(e);
      }
    }
  }
}

customElements.define('cart-notification', CartNotification);
